/**
 * The CRM module's frontend manifest — everything it adds to the interface, in
 * one place. The backend half is `backend/src/modules/crm/`.
 *
 * Its menu entries sit in a "Sales" section this module declares — any other
 * module selling something declares the same id and joins it. Without
 * `crm.read` every entry is hidden, and the section with them.
 */
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import ViewWeekOutlinedIcon from '@mui/icons-material/ViewWeekOutlined';
import { CRM_PERMISSIONS } from '@forsys/shared';
import { defineFrontendModule } from '../types';
import ActivitiesPage from './ActivitiesPage';
import DealPage from './DealPage';
import DealsPage from './DealsPage';
import OrganizationPage from './OrganizationPage';
import OrganizationsPage from './OrganizationsPage';
import PersonPage from './PersonPage';
import PersonsPage from './PersonsPage';
import StagesPage from './StagesPage';

const READ = [CRM_PERMISSIONS.READ];

export const crmModule = defineFrontendModule({
  key: 'crm',
  // Between Overview (100) and Content (300), where core's own section was.
  sections: [{ id: 'sales', titleKey: 'crm:nav.section.sales', order: 200 }],
  pages: [
    {
      path: 'crm/deals',
      element: <DealsPage />,
      anyOf: READ,
      nav: { section: 'sales', labelKey: 'crm:nav.deals', icon: HandshakeOutlinedIcon },
    },
    { path: 'crm/deals/:id', element: <DealPage />, anyOf: READ },
    {
      path: 'crm/activities',
      element: <ActivitiesPage />,
      anyOf: READ,
      nav: { section: 'sales', labelKey: 'crm:nav.activities', icon: ChecklistOutlinedIcon },
    },
    {
      path: 'crm/persons',
      element: <PersonsPage />,
      anyOf: READ,
      nav: { section: 'sales', labelKey: 'crm:nav.persons', icon: ContactsOutlinedIcon },
    },
    { path: 'crm/persons/:id', element: <PersonPage />, anyOf: READ },
    {
      path: 'crm/organizations',
      element: <OrganizationsPage />,
      anyOf: READ,
      nav: { section: 'sales', labelKey: 'crm:nav.organizations', icon: BusinessOutlinedIcon },
    },
    { path: 'crm/organizations/:id', element: <OrganizationPage />, anyOf: READ },
    {
      path: 'crm/stages',
      element: <StagesPage />,
      anyOf: [CRM_PERMISSIONS.ADMIN],
      nav: { section: 'sales', labelKey: 'crm:nav.stages', icon: ViewWeekOutlinedIcon },
    },
  ],
});
